import styled from "styled-components";
import {
  BRAND,
  NOTICE,
  NOTICE_LIGHTEST,
  TEXT_SECONDARY
} from "@streeteasy/design-system/colors";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import { Caption } from "@streeteasy/design-system/typography";

import ListingCard from "src/shared/components/ListingCard";
import { smallScreen } from "src/shared/constants/screenSizes";

export const Listing = styled(ListingCard)`
  flex: 1;
`;

export const SeeMoreButton = styled(TextLink).attrs({ asElement: "button" })`
  color: ${BRAND};
  text-transform: uppercase;

  &:active,
  &:focus,
  &:hover {
    background-color: ${NOTICE_LIGHTEST};
    border-bottom-color: transparent;
    color: ${NOTICE};
    fill: ${NOTICE};
  }
`;

export const SeeMoreCopy = styled(Caption)`
  color: ${TEXT_SECONDARY};
  margin-right: 8px;
`;

export const SeeMoreDivider = styled.span`
  color: ${TEXT_SECONDARY};
  padding: 0 4px;
`;

export const SeeMoreSection = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;

  @media screen and (max-width: ${smallScreen}px) {
    justify-content: flex-end;
  }
`;

export const SlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
